import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import "./LiveMovers.css";

import { ReactComponent as Arrow } from "../../../../../../assets/icons/triangle-arrow.svg";

const TOP_MOVERS = graphql`
  query LiveMoversQuery($eventId: ID!, $round: Int!) {
    pgaTopMovers(eventId: $eventId, eventRound: $round) {
      risers {
        id

        positionMovementValue
      }

      fallers {
        id

        positionMovementValue
      }
    }
  }
`;

export default function LiveMovers(props) {
  const data = useLazyLoadQuery(TOP_MOVERS, {
    eventId: props.selectedEventID,
    round: props.round,
  });

  return (
    <div className="pga-live-movers-container">
      <h1>Top Movers</h1>

      {data.pgaTopMovers.risers.map((round) => {
        return (
          <div key={round.id} className="pga-live-movers-player">
            <div className="pga-live-movers-value">
              <Arrow fill="green" className="pga-live-movers-up-arrow" />
              <span>
                <strong>{round.positionMovementValue}</strong>
              </span>
            </div>
            <h3>
              {round.player.firstName} {round.player.lastName}
            </h3>
          </div>
        );
      })}
      <br />
      {data.pgaTopMovers.fallers.map((round) => {
        return (
          <div key={round.id} className="pga-live-movers-player">
            <div className="pga-live-movers-value">
              <Arrow fill="red" className="pga-live-movers-down-arrow" />
              <span>
                <strong>{round.positionMovementValue}</strong>
              </span>
            </div>
            <h3>
              {round.player.firstName} {round.player.lastName}
            </h3>
          </div>
        );
      })}
    </div>
  );
}
